import React from 'react';
import {MarkdownContent} from '../VideoPlayer/VideoPlayer';
import styles from './terms-and-conditions.module.css';

type TTermsAndConditionsProps = {
    data: any;
    key?: number;
};
export const TermsAndConditions: React.FC<TTermsAndConditionsProps> = ({
    data
}) => {
    return (
        <div className={styles.tncWrapper}>
            <div
                style={{
                    ...(data?.textColor && {color: data?.textColor}),
                    ...(data?.backgroundColor && {
                        backgroundColor: data?.backgroundColor
                    })
                }}
                className={styles.tncContainer}
            >
                <MarkdownContent
                    content={data?.title}
                    className={styles.tncHeading}
                    dataTarget=""
                />
                <MarkdownContent
                    content={data?.description}
                    className={styles.tncDescription}
                    dataTarget=""
                />
            </div>
        </div>
    );
};
